import EntityMapper from '../EntityMapper';

import PositionMapper, {
  PositionData,
} from '../../../value_objects/mappers/PositionMapper';

import CharacterShowCommand from '../../../../domain/entities/commands/CharacterShowCommand';
import ResourcesSet from '../../../../domain/entities/resources/ResourcesSet';

import CharacterCommandOptionsMapper, {
  CharacterCommandOptionsData,
} from '../../../value_objects/mappers/command_options/CharacterCommandOptionsMapper';

export interface CharacterShowCommandData {
  id: number;
  scene_id: number;
  type: 'character_show';
  character_id: number;
  position: PositionData;
  face: string;
  mark_id: number | null;
  options?: CharacterCommandOptionsData;
}

export default class CharacterShowCommandMapper
  implements EntityMapper<CharacterShowCommandData, CharacterShowCommand>
{
  private positionMapper: PositionMapper;
  private characterCommandOptionsMapper: CharacterCommandOptionsMapper;

  constructor(private resourcesSet: ResourcesSet) {
    this.positionMapper = new PositionMapper();
    this.characterCommandOptionsMapper = new CharacterCommandOptionsMapper();
  }

  public map(obj: CharacterShowCommandData): CharacterShowCommand {
    const position = this.positionMapper.map(obj.position);
    const options = this.characterCommandOptionsMapper.map(obj.options || {});
    return new CharacterShowCommand(
      obj.id,
      obj.scene_id,
      this.resourcesSet.getCharacterResource(obj.character_id),
      position,
      obj.face,
      obj.mark_id ? this.resourcesSet.getMarkResource(obj.mark_id) : null,
      options,
    );
  }
}
